export function formatCategoryTree(data, parentId = null) {
    return data.map(node => {
        const transformedNode = {
            id: node.id,
            name: node.name,
            parentId: parentId,
            expanded: parentId ? false : true
        };

        if (node.children && node.children.length > 0) {
            transformedNode.items = formatCategoryTree(node.children, node.id);
        }

        return transformedNode;
    });
}


export function formatCategoryKeyValue(data) {
    let flatCategories = [];

    data.forEach(node => {
        const transformedNode = {
            id: node.id,
            name: node.name,
        };

        flatCategories.push(transformedNode);

        if (node.children && node.children.length > 0) {
            const childCategories = formatCategoryKeyValue(node.children);
            flatCategories = flatCategories.concat(childCategories);
        }
    });

    return flatCategories;
}